import styled from "styled-components";

export const FpContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  justify-content: center;
  align-items: center;
  animation: fade-in 0.3s forwards;
`;

export const FpCenter = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const FpLoader = styled.div`
  span {
    display: inline-block;
    background-color: var(--color-azul-mrpay);
    width: 0px;
    height: 0px;
    border-radius: 50%;
    border: 1px solid white;
    margin: 0 8px;
    animation: bounce 0.6s infinite alternate;
    transform: translate3d(0);

    &:nth-child(2) {
      background-color: var(--color-dourado-mrpay);
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }

    @keyframes bounce {
      to {
        width: 16px;
        height: 16px;
        transform: translate3d(0, -16px, 0);
      }
    }
  }
`;
